import { createAction, props } from '@ngrx/store';

const GET_USER = '[Auth] Get User';
const SET_USER = '[Auth] Set User';
const UPDATE_USER = '[Auth] Update User';
const DELETE_USER = '[Auth] Delete User';
const LOGOUT_USER = '[Auth] Logout User';
const LOGIN_FAILURE = '[Auth] Login Failure';
const getUser = createAction(GET_USER, props<{ authApiConstants: any }>());

const setUser = createAction(SET_USER, props<{ userData: any }>());

const updateUser = createAction(UPDATE_USER, props<{ userData: any }>());

const deleteUser = createAction(DELETE_USER, props<{ userData: any }>());

const logoutUser = createAction(LOGOUT_USER);
const loginFailure = createAction(LOGIN_FAILURE, props<{ loginError: any }>());
export { getUser, setUser, updateUser, deleteUser, logoutUser, loginFailure };
